import { useIsomorphicLayoutEffect } from '@cian/react-utils';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { selectIsWebview } from '../../selectors/page';

interface IInWebviewProps {
  children: React.ReactElement;
}

export const InWebview: React.VFC<IInWebviewProps> = ({ children }) => {
  const [isMounted, setIsMounted] = React.useState(false);
  const isWebview = useSelector(selectIsWebview);

  useIsomorphicLayoutEffect(() => {
    setIsMounted(true);
  }, []);

  if (isMounted && isWebview) {
    return children as React.ReactElement;
  }

  return null;
};
